import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// Redirects to the combined dashboard/targets page
const CodeScanTargetsPage: React.FC = () => {
  const navigate = useNavigate();
  useEffect(() => { navigate('/security/code-scan', { replace: true }); }, [navigate]);
  return null;
};

export default CodeScanTargetsPage;
